import { useEffect, useRef, useState } from 'react';
import { attemptAutoReload } from '../connection';

// Recovery for a load that's stuck past `ms`. Instead of just revealing a Reload
// button, it first tries a guarded automatic reload (a full reload reliably
// re-establishes a Firestore connection that died while the phone slept). Only if
// that auto-reload is suppressed — offline, or one was already tried very recently
// (so we don't loop) — does it fall back to showing the manual button.
//
// Returns `showReload` (true → render a Reload button as the last resort).
export default function useStallRecovery(loading, ms = 7000) {
  const [showReload, setShowReload] = useState(false);
  const handled = useRef(false);

  useEffect(() => {
    if (!loading) { setShowReload(false); handled.current = false; return undefined; }
    const t = setTimeout(() => {
      if (handled.current) { setShowReload(true); return; }
      handled.current = true;
      // Try to self-heal. If a reload starts, this page is going away; if it's
      // suppressed (offline / just reloaded), surface the manual button.
      const reloading = attemptAutoReload();
      if (!reloading) setShowReload(true);
    }, ms);
    return () => clearTimeout(t);
  }, [loading, ms]);

  return showReload;
}
